import axios from "axios";
import { environment } from "../environments/environment";

const api = axios.create({
    baseURL: environment.baseURL,
    headers: {
        'Content-Type': 'application/json',
        'authorization': 'bXVsdGlwb3J0YWxXczp5QV5VTVNldl4wd3g=='
    }
})

export default api;